// Retrieve element type from array type
// Ex: ElementType<string[]> === string
export type ElementType<A> = A extends readonly (infer T)[] ? T : never;

export const notNullish = <T>(value: T | null | undefined): value is T => {
  if (value === null || value === undefined) return false;
  return true;
};

/**
 * Make single or some props optional
 */
export type Optional<T, K extends keyof T> = Omit<T, K> & Pick<Partial<T>, K>;

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};
